import * as React from 'react';

import * as styles from './FakeControlWrapper.css';

type TDivElementProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
type TFakeControlWrapperProps = Omit<TDivElementProps, 'className' | 'style'>;

export const FakeControlWrapper: React.FC<React.PropsWithChildren<TFakeControlWrapperProps>> = props => {
  return <div className={styles['wrapper']} {...props} />;
};
FakeControlWrapper.displayName = 'FakeControlWrapper';
